const DateMask = (input) => {
  if (input.length == 2 || input.length == 5) {
    input = input + '/';
  }
  return input;
}
const PhoneNumber = (input) => {
  return input = input.replace(/[^0-9]+/g, "");
}
const CMNDNumber = (input) => {
  return input = input.replace(/[^0-9a-zA-Z]+/g, "");
}
const checkEmail = (email) => {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var checkUnicode = /[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ]/;
  return re.test(email) && email.match(checkUnicode) == null;
}

export {DateMask, PhoneNumber, CMNDNumber, checkEmail};



// WEBPACK FOOTER //
// ./src/lib/validate.js